import { useQuery } from '@apollo/client';

import { ModulePage } from '~/components/ModulePage/ModulePage';
import { ModuleSlot } from '~/components/ModuleSlot/ModuleSlot';
import { ModuleSlotId, ModuleType, useRiskCountryReport } from '~/modules';

import { CountryReportDetailHeader } from './components/CountryReportDetailHeader/CountryReportDetailHeader';
import { COUNTRY_REPORT_DETAIL_QUERY } from './CountryReportDetail.gql';

export const CountryReportDetail = () => {
  const { id } = useRiskCountryReport();

  const { data, loading } = useQuery(COUNTRY_REPORT_DETAIL_QUERY, { variables: { id } });

  return (
    <ModulePage
      header={<CountryReportDetailHeader name={data?.cataclysm.countryReport.name ?? ''} />}
      modules={
        loading ? null : (
          <ModuleSlot
            id={ModuleSlotId.MAIN}
            modules={[
              {
                id: '0f0671a1-ee85-490f-a1e5-61bc9fea1609',
                moduleType: ModuleType.RISK_COUNTRY_REPORT_TABLE_WIDGET,
                grid: { size: { sm: 12, md: 12, xl: 12 } },
              },
            ]}
          />
        )
      }
    />
  );
};
